import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface Message {
  id: string
  type: 'user' | 'ai'
  message: string
}

interface ChatbotStore {
  open: boolean
  messages: Message[]
  chatbot_id: string
  setOpen: (open: boolean) => void
  setMessages: (messages: Message[]) => void
  setChatbotId: (chatbot_id: string) => void
  clearMessages: () => void
}

const initialState: ChatbotStore = {
  open: false,
  messages: [],
  chatbot_id: '',
  setOpen: () => {},
  setMessages: () => {},
  setChatbotId: () => {},
  clearMessages: () => {},
}

export const useChatbotStore = create(
  persist(
    immer<ChatbotStore>((set) => ({
      ...initialState,
      setOpen: (open) =>
        set((state) => {
          state.open = open
        }),
      setMessages: (messages) =>
        set((state) => {
          state.messages = messages
        }),
      setChatbotId: (chatbot_id) =>
        set((state) => {
          state.chatbot_id = chatbot_id
        }),
      clearMessages: () =>
        set((state) => {
          state.messages = []
        }),
    })),
    {
      name: 'chatbot-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
